(function () {
  var proxyPath = '/apps/discount-related-items';
  var serviceUrl = 'https://slc-discount-related-items.vercel.app/api/discount-related-items';
  var giftProperty = '_related_discount_code';
  var originalFetch = window.fetch;

  if (!originalFetch || window.__slcDiscountRelatedItemsBridgeLoaded) return;
  window.__slcDiscountRelatedItemsBridgeLoaded = true;

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function parseBody(init) {
    if (!init || !init.body || typeof init.body !== 'string') return null;

    try {
      return JSON.parse(init.body);
    } catch (error) {
      return null;
    }
  }

  function isCartUpdateDiscountRequest(url, init) {
    if (url.pathname !== '/cart/update.js') return false;

    var body = parseBody(init);
    return Boolean(body && typeof body.discount === 'string');
  }

  function giftCodeFromDiscountString(discountString) {
    var codes = String(discountString || '')
      .split(',')
      .map(normalizeCode)
      .filter(Boolean);

    return codes.find(function (code) {
      return (
        code === 'FREETUMBLER' ||
        code === 'FREECAP' ||
        code.indexOf('TUMB-') === 0 ||
        code.indexOf('TUMBLER-') === 0 ||
        code.indexOf('CAP-') === 0
      );
    });
  }

  async function fetchRelatedItems(code) {
    var response = await originalFetch.call(
      window,
      serviceUrl + '?code=' + encodeURIComponent(code),
      { headers: { Accept: 'application/json' } }
    );

    if (!response.ok) return [];

    var data = await response.json();
    return Array.isArray(data.items) ? data.items : [];
  }

  async function addMissingGiftItems(code, items) {
    if (!items.length) return;

    var cartResponse = await originalFetch.call(window, '/cart.js', {
      headers: { Accept: 'application/json' },
    });
    var cart = await cartResponse.json();

    var itemsToAdd = items
      .map(function (item) {
        var id = Number(item.id || item.variantId);
        var quantity = Number(item.quantity || 1);
        if (!id) return null;

        var alreadyInCart = cart.items.some(function (line) {
          return (
            Number(line.id) === id &&
            line.properties &&
            normalizeCode(line.properties[giftProperty]) === code
          );
        });

        if (alreadyInCart) return null;

        var properties = {};
        properties[giftProperty] = code;

        return {
          id: id,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
          properties: properties,
        };
      })
      .filter(Boolean);

    if (!itemsToAdd.length) return;

    await originalFetch.call(window, '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: itemsToAdd }),
    });
  }

  window.fetch = async function (input, init) {
    var requestUrl = typeof input === 'string' ? input : input && input.url;

    try {
      var url = new URL(requestUrl, window.location.origin);

      if (url.pathname === proxyPath) {
        var replacement = new URL(serviceUrl);
        replacement.search = url.search;
        return originalFetch.call(this, replacement.toString(), init);
      }

      if (isCartUpdateDiscountRequest(url, init)) {
        var body = parseBody(init);
        var code = giftCodeFromDiscountString(body.discount);

        if (code) {
          var relatedItems = await fetchRelatedItems(code);
          await addMissingGiftItems(code, relatedItems);
        }
      }
    } catch (error) {
      return originalFetch.apply(this, arguments);
    }

    return originalFetch.apply(this, arguments);
  };
})();